import {createFeatureSelector, createSelector} from "@ngrx/store";
import {Revisione53State, STATE_KEY_REVISIONE53} from "../revisione53.reducers";
import {Revisione53DatiBusinessSelectors} from "./dati-business.selectors";
import {parse} from 'date-fns'

const revisione53State = createFeatureSelector<Revisione53State>(STATE_KEY_REVISIONE53)

export abstract class Revisione53CoreSelectors {

  static getLastSave = createSelector(
    revisione53State,
    state => {
      const md5 = state.revisione.md5;
      let date = new Date(Number(state.revisione.dataultimosalvataggio));
      if(date instanceof Date && !isNaN(date.getTime())){
        return { md5, dataultimosalvataggio: date }
      } else {
        return {md5, dataultimosalvataggio: parse(state.revisione.dataultimosalvataggio?.toString(),'dd/MM/yyyy', new Date())}
      }
    }
  )

  static getMyVerbale = createSelector(
    revisione53State,
    state => state.revisione?.dati?.my_Verbale
  )

  static getUpdateError = createSelector(
    revisione53State,
    state => !!state.updateError
  )

  static getRevisione = createSelector(
    revisione53State,
    state => state.revisione
  )

  static getRevisioneAndDatiBusiness = createSelector(
    Revisione53CoreSelectors.getRevisione,
    Revisione53DatiBusinessSelectors.getDatiBusiness,
    (revisione, datiBusiness) => ({revisione, datiBusiness})
  )

  static getBilancioAllegato = createSelector(
    revisione53State,
    state => state.revisione.dati.my_Verbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato
  )

  static getDatiBilancio = createSelector(
    revisione53State,
    state => state.revisione.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiBilancio
  )

}
